"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NameValueItem = NameValueItem;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Generic key-value component.
 *
 * @example
 * import { NameValueItem }from '@ta-interaktiv/react-publication-info'
 *
 * function Component(props) {
 *   return(
 *     <NameValueItem
 *       name='Version'
 *       value='1.0.0'
 *       itemClassName='ui label'
 *       valueClassName='detail'
 *     />
 *   )
 * }
 *
 * // returns <span className="name-value-item ui label">
 * //           <span className="name ">Version</span>
 * //           <span className="value detail">1.0.0</span>
 * //         </span>
 *
 *
 * @param {object} props
 * @param {string} [props.name] The name or key of the information.
 * @param {string} [props.value] The value. If null or undefined, the component will not render.
 * @param {string} [props.itemClassName] Class name(s) for the whole item.
 * @param {string} [props.nameClassName] Class names(s) for the key  part.
 * @param {string} [props.valueClassName] Class names(s) for the value part.
 */
function NameValueItem(_ref) {
  var name = _ref.name,
      value = _ref.value,
      _ref$itemClassName = _ref.itemClassName,
      itemClassName = _ref$itemClassName === void 0 ? '' : _ref$itemClassName,
      _ref$nameClassName = _ref.nameClassName,
      nameClassName = _ref$nameClassName === void 0 ? '' : _ref$nameClassName,
      _ref$valueClassName = _ref.valueClassName,
      valueClassName = _ref$valueClassName === void 0 ? '' : _ref$valueClassName;

  if (!value) {
    return null;
  }

  return _react.default.createElement("span", {
    className: "name-value-item ".concat(itemClassName)
  }, name && name !== '' && _react.default.createElement("span", {
    className: "name ".concat(nameClassName)
  }, name, "\xA0"), _react.default.createElement("span", {
    className: "value ".concat(valueClassName)
  }, value));
}

var _default = NameValueItem;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ta-interaktiv/react-publication-info/dist/name-value-item.js
// module id = 491
// module chunks = 0